import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import "./contentStyle.css";
import pdficon from "./../Asset/PDF.png";
import passschema from "./../Asset/passschema.png";
import acceptschema from "./../Asset/acceptschema.png";
import failedschema from "./../Asset/failedschema.png";
import { Link, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useSelector } from "react-redux";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "./../Rightsidebar/Rightsidebar";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../Context/Context";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Commonfun } from './../Commonfun';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import CommonAlert from "../../../Commonalert/commonalert";
import { Breadcrumbs, Typography } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import UserActivityTracker from "../../../hooks/userActivityTracker";



export default function ContentauditDetail({ reportStatus = false, instantReport = "" }) {
  const [cardData, setCardData] = useState([]);
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [jobDate, setjobDate] = useState("");
  const [toggle, setToggle] = useState(false);
  const [faqData, setfaqData] = useState("2")
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const navigate = useNavigate();
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value

  let querystring = useParams();
  let cont_audit_id = querystring.id;
  let job_audit_id = querystring.jobid;


  useEffect(() => {
    if (reportStatus) {
      applyInstantReport();
    } else {
      callUserdataApi();
    }
    faqdatafun();
  }, [instantReport]);
  const callUserdataApi = async () => {
    setLoading(true);
    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}content/v2/analysis_summary_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${cont_audit_id}&job_id=${job_audit_id}`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });
    const dataval = datavalue?.data;
    setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));

    setCardData(dataval);
  };

  const applyInstantReport = () => {

    if (instantReport) {
      const dataval = instantReport;
      setjobDate(moment(instantReport?.job_date).format("MMMM DD,YYYY HH:mm"));

      setCardData(dataval);
    };
  }


  const apihandleClose = () => {
    setapiOpen(false);
  };
  const pdfdown = async () => {
    setIsDownloading(true);
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}content/v2/analysis_summary_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${cont_audit_id}&job_id=${job_audit_id}&formats=pdf&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("AnalysisSummaryDetail", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.error('Failed to fetch PDF:', response.status, response.statusText);
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setIsDownloading(false);
    setLoading(false);

  }
  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=11`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }

  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleDownlodingPDF = () => {
    pdfdown();
  }


  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Analysis Summary Detail</title>
      </Helmet>

      {!reportStatus &&
        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={4}>
                <div>
                  <h1 className="dashboard_header">
                    Analysis Summary Detail Report
                    <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                  </h1>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <div className="top_breadcrumb_menu">
                  <div className="exportpdf_outer">
                    <div className="breadcrumb-wrapper">
                      <CommonBreadCrumb breadcrumbValue={[
                        { title: 'Content' },
                        { title: 'Analysis Summary', activeColor: true, link: '/analysis-summary' },
                        { title: 'Analysis Summary Detail', activeColor: true }
                      ]} />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
      }

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <a target="_blank" href={cardData?.url} style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink" style={{ flexDirection: "column" }}>
                    {cardData?.url}
                  </span>
                </a>
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            {!reportStatus &&
              <Grid item xs={12} md={6}>
                {/* <button className="exportpdf" alt="pdf icon" onClick={isDownloading ? null : pdfdown} title="PDF Download" ><GetAppIcon />PDF</button> */}

                <div className="download-pdf-ceneter" style={{ display: "block", textAlign: "end" }}>
                  <div className="dashboard_download" style={{ justifyContent: "end", display: "inline-flex", cursor: "pointer" }} onClick={isDownloading ? null : pdfdown}>
                    Download PDF
                    <svg
                      className="filter"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      viewBox="0 0 24 24"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7 10 12 15 17 10" />
                      <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                  </div>
                </div>
              </Grid>
            }
          </Grid>
        </Box>
      </Container>
        <Container maxWidth={false} className="dashboard-container">
                    <Box className="dashboard-box-tab">
                      <Grid container className="dashboard-grid">
                        <Grid item xs={12} md={12}>
                          <div className="trendy-tabs-wrapper">
                            <div className="trendy-tab-container">
                         <Link to="#">
                            <button
                              type="button"
                              data-id="overall_content_analysis"
                              data-name="Overall Content Analysis"
                              className="trendy-tab active"
                            >
                              Overall Content Analysis
                            </button>
                          </Link>
      {cont_audit_id && (
                          <Link to={`/content-detail/ai-analysis-summary/${cont_audit_id}/${job_audit_id}`}>
                            <button
                              type="button"
                              data-id="ai_suggestion"
                              data-name="AI Suggestion"
                              className="trendy-tab "
                            >
                              AI Suggestion
                            </button>
                          </Link>
      )}
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </Box>
                  </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div>
                <div className="cnt_hdr_content_table grid_table_shodow" style={{ background: "#fff", marginBottom: "20px", paddingLeft: "10px" }}>
                  <div className="box_wrap">
                    <div className="hor_line">
                      <h3 className="download-pdf-ceneter">Passed</h3>
                    </div>
                    <table className="table">
                      <col style={{ width: "5%" }} />
                      <col style={{ width: "35%" }} />
                      <col style={{ width: "50%" }} />
                      <col style={{ width: "20%" }} />
                      <tbody>
                        {cardData?.passed_audit?.map((row, index) => (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{row?.description}</td>
                            <td dangerouslySetInnerHTML={{ __html: row?.result }}></td>
                            <td>
                              <img src={passschema} alt="pass" />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="cnt_hdr_content_table grid_table_shodow" style={{ background: "#fff", marginBottom: "20px", paddingLeft: "10px" }}>
                  <div className="box_wrap">
                    <div className="hor_line">
                      <h3 className="download-pdf-ceneter">Acceptable</h3>
                    </div>
                    <table className="table">
                      <col style={{ width: "5%" }} />
                      <col style={{ width: "35%" }} />
                      <col style={{ width: "50%" }} />
                      <col style={{ width: "20%" }} />
                      <tbody>
                        {cardData?.okay_audit?.map((row, index) => (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{row.description}</td>
                            <td dangerouslySetInnerHTML={{ __html: row.result }}></td>
                            <td>
                              <img src={acceptschema} alt="accept" />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="cnt_hdr_content_table grid_table_shodow" style={{ background: "#fff", marginBottom: "20px", paddingLeft: "10px" }}>
                  <div className="box_wrap">
                    <div className="hor_line">
                      <h3 className="download-pdf-ceneter">Failed</h3>
                    </div>
                    <table className="table">
                      <col style={{ width: "5%" }} />
                      <col style={{ width: "35%" }} />
                      <col style={{ width: "50%" }} />
                      <col style={{ width: "20%" }} />
                      <tbody>
                        {cardData?.failed_audit?.map((row, index) => (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{row.description}</td>
                            <td dangerouslySetInnerHTML={{ __html: row?.result }}></td>
                            <td>
                              <img src={failedschema} alt="failed" />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {!reportStatus &&
        <Container maxWidth={false} className="footer-container">
          <Box className="footer-box">
            <Grid container className="footer-grid">
              <Grid item xs={12} md={6}>
                <div className="footer-left">
                  <p className="footer-text">
                    All Rights Reserved Copyright © 2026 |
                    <a href="https://www.egrovesys.com/" target="blank">
                      <span className="footer-brand"> Elite site Optimizer</span>
                    </a>
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="footer-right">
                  <p>{/* Add content if needed */}</p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
      }

      {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}


      {/* <div className="cnt_audit_outer_wrap ContentAuditWrap">
        <div className="top_breadcrumb_menu">
          <CommonBreadCrumb breadcrumbValue={[
            { title: 'Content' },
            { title: 'Analysis Summary', activeColor: true, link: '/analysis-summary' },
            { title: 'Analysis Summary Detail', activeColor: true }
          ]} />
          <div className="exportpdf_outer">
            <button onClick={handleToggle} className="faq_class exportpdf" title="Frequently Asked Question" >
              <QuestionMarkIcon />

            </button>

            <>
              <button className="exportpdf" alt="pdf icon" onClick={isDownloading ? null : pdfdown} title="PDF Download" ><GetAppIcon />PDF</button>
            </>

          </div>
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

        </div>


        <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <div >

              <h2 className="heading_font">Analysis Summary Detail Report </h2>
              <a target="_blank" href={cardData?.url} style={{ display: 'flex', flexDirection: 'column' }}>
                <span className="spanlink" style={{ flexDirection: "column" }}>
                  {cardData?.url}
                </span>
              </a>

              <p style={{ fontSize: "14px", letterSpacing: "0.8px", color: "#ff601fc2" }}>as of {timezonechange(jobDate)}  <span style={{ fontWeight: 700 }}>  {timezoneval()} </span></p>

            </div>
          </div>
        </div>
        <div className="cnt_hdr_content_table">
          <div className="box_wrap">
            <div className="hor_line">
              <h3>Passed</h3>
            </div>
            <table className="table">
              <col style={{ width: "5%" }} />
              <col style={{ width: "35%" }} />
              <col style={{ width: "50%" }} />
              <col style={{ width: "20%" }} />
              <tbody>
                {cardData?.passed_audit?.map((row, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{row?.description}</td>
                    <td dangerouslySetInnerHTML={{ __html: row?.result }}></td>
                    <td>
                      <img src={passschema} alt="pass" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="cnt_hdr_content_table">
          <div className="box_wrap">
            <div className="hor_line">
              <h3>Acceptable</h3>
            </div>
            <table className="table">
              <col style={{ width: "5%" }} />
              <col style={{ width: "35%" }} />
              <col style={{ width: "50%" }} />
              <col style={{ width: "20%" }} />
              <tbody>
                {cardData?.okay_audit?.map((row, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{row.description}</td>
                    <td dangerouslySetInnerHTML={{ __html: row.result }}></td>
                    <td>
                      <img src={acceptschema} alt="accept" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="cnt_hdr_content_table">
          <div className="box_wrap">
            <div className="hor_line">
              <h3>Failed</h3>
            </div>
            <table className="table">
              <col style={{ width: "5%" }} />
              <col style={{ width: "35%" }} />
              <col style={{ width: "50%" }} />
              <col style={{ width: "20%" }} />
              <tbody>
                {cardData?.failed_audit?.map((row, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{row.description}</td>
                    <td dangerouslySetInnerHTML={{ __html: row?.result }}></td>
                    <td>
                      <img src={failedschema} alt="failed" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div> */}
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }
      <UserActivityTracker pagename="Content - Analysis summary - Detail" />
    </div>
  );
}